import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
        client_contact_container: {
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            flexGrow: 1,
            width: '100%',
            overflow: 'auto',
            "@media (max-width: 800px)": {
                flexDirection: 'column'
            }
        },
        btn_container: {
            backgroundColor: theme.palette.grey[200],
            width: '300px',
            height: '200px',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            boxSizing: 'border-box',
            alignItems: 'center',
            color: theme.palette.grey[500],
            "&:hover": {
                backgroundColor: theme.palette.grey[300],
            },
            "& > div:first-child": {
                fontSize: 20
            },
            "& > div svg": {
                fontSize: 100
            }
        },
        select_client_btn: {
            borderRadius: '8px 0 0 8px',
            borderLeft: `20px solid ${theme.palette.secondary.light}`,
            borderRight: `3px solid ${theme.palette.secondary.light}`
        },
        select_contact_btn: {
            borderRadius: '0 8px 8px 0',
            borderRight: `20px solid ${theme.palette.secondary.light}`
        },
        search_container: {
            backgroundColor: theme.palette.grey[50],
            width: '300px',
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            boxSizing: 'border-box',
        },
        search_client_container: {
            border: `1px solid ${theme.palette.secondary.light}30`,
            borderRight: `3px solid ${theme.palette.secondary.light}`,
            borderRadius: '8px 0 0 8px',
        },
        search_input_container: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            boxSizing: 'border-box',
            height: '40px',
            background: theme.palette.common.white,
            borderRadius: '8px 0 0 0',
            borderBottom: `1px solid ${theme.palette.secondary.light}30`,
        },
        btn: {
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: theme.palette.grey[100],
            width: '40px',
            lineHeight: '5px',
            "&:hover": {
                backgroundColor: theme.palette.grey[200],
            },
            "& > span": {
                fontSize: '9px',
                fontWeight: 800
            }
        },
        add_btn: {
            borderRadius: '8px 0 0 0',
            "& > svg": {
                color: theme.palette.primary.dark
            }
        },
        remove_btn: {
            "& > svg": {
                color: theme.palette.error.light
            }
        },
        search_input: {
            padding: "8px",
            flexGrow: 1,
            "& > input": {
                width: '100%',
                border: 'none',
                color: theme.palette.grey[400],
                fontSize: '16px',
                "&:focus": {
                    outline: 'none'
                }
            }
        },
        elements_container: {
            display: 'flex',
            flexDirection: "column",
            width: '100%',
            overflowY: 'scroll'
        },
        options_body: {
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },
        loading: {
            color: theme.palette.primary.light
        },
        empty_container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.grey[400],
            fontSize: "20px",
            height: '100%',
            padding: '10px',
            boxSizing: 'border-box',
            textAlign: 'center',
            "& > div:last-child": {
                fontSize: "12px",
            }
        },
        name_container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            "& > svg": {
                fontSize: 50,
                color: theme.palette.primary.dark
            },
            "& > span": {
                fontSize: 14,
                color: theme.palette.secondary.light
            }
        },
        value_container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            "& > svg": {
                fontSize: 18,
                color: theme.palette.primary.dark,
                marginRight: '4px'
            },
            "& > span": {
                fontSize: 14,
                color: theme.palette.secondary.light
            }
        },
        btn_selected_container: {
            backgroundColor: theme.palette.grey[50],
            width: '300px',
            height: '200px',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            boxSizing: 'border-box',
            alignItems: 'center',
            color: theme.palette.grey[500],
            lineHeight: '10px',
            "&:hover": {
                backgroundColor: theme.palette.grey[200],
            }
        },
        selected_client_btn: {
            borderRadius: '8px 0 0 8px',
            borderLeft: `20px solid ${theme.palette.primary.dark}`,
            borderRight: `3px solid ${theme.palette.secondary.light}`
        },
        modal_container: {
            height: 600,
            width: 1000,
            display: 'flex',
            flexDirection: "column",
            position: 'relative'
        },
        data_container: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.grey[400]}`,
            borderRadius: '8px',
        },
        info_container: {
            display: 'grid',
            gridTemplateColumns: "48% 4% 48%",
            columnGap: '8px',
            flexGrow: 1
        },
        contact_info_container: {
            display: 'flex',
            flexDirection: 'column',
            lineHeight: '12px',
            padding: 6,
            borderRadius: '0 8px 8px 0',
            backgroundColor: theme.palette.grey[200],
            "& > *:first-child": {
                fontWeight: 700
            },
            "& > *:last-child": {
                color: theme.palette.grey[400]
            }
        },
        client_info_container: {
            display: 'flex',
            flexDirection: 'column',
            lineHeight: '12px',
            borderRadius: '7px 0 0 7px',
            padding: 6,
            backgroundColor: theme.palette.grey[200],
            "& > *:first-child": {
                fontWeight: 700
            },
            "& > *:last-child": {
                color: theme.palette.grey[400]
            }
        },
        search_btn: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        select_btn: {
            alignSelf: 'flex-end',
            marginTop: '10px',
            marginRight: '20px'
        },
        full_width: {
            width: '100%',
            borderRadius: '7px',
        },
    }))
;

export {useStyles}